import styled, { css, DefaultTheme } from 'styled-components';
import StatCard from '@components/StatCard';
import { Col } from 'antd';

export type StatType =
  | 'totalConsumption'
  | 'franchiseConsumption'
  | 'surplusConsumption'
  | undefined;

const statColor = (theme: DefaultTheme, type?: StatType) => {
  switch (type) {
    case 'totalConsumption':
      return theme.colors.green;
    case 'franchiseConsumption':
      return theme.colors.blue;
    case 'surplusConsumption':
      return theme.colors.red;
    default:
      return theme.colors.orange;
  }
};

export const ColCurrentConsumption = styled(Col)`
  padding: 0 16px !important;
  color: ${({ theme }) => theme.colors.text1};
`;

export const ColRateConsumption = styled(Col)<{
  hasCurrentConsumption: boolean;
}>`
  border-radius: 8px;
  padding: 4px 16px !important;
  padding-bottom: 12px !important;
  height: 100%;
  color: ${({ theme }) => theme.colors.text1};

  ${({ hasCurrentConsumption, theme }) =>
    hasCurrentConsumption &&
    css`
      background: ${theme.colors.background1};
      border: 1px dashed ${theme.colors.border};
      padding-bottom: 12px;
    `}
`;

export const ConsumptionStat = styled(StatCard)<{ type?: StatType }>`
  span {
    font-size: 1.6rem;
    color: ${({ theme, type }) => statColor(theme, type)};
  }

  margin: 0;

  div {
    padding: 4px 8px;
  }

  border-bottom: 2px solid ${({ theme, type }) => statColor(theme, type)} !important;

  .ant-statistic-title {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1rem;

    .anticon {
      font-size: inherit;
      color: inherit;
    }
  }

  .ant-statistic-content-value {
    margin: 0;
    font-size: 1.3rem;
    line-height: 1.4rem;
  }
`;

export const ConsumptionSectionHeader = styled.div`
  padding: 0 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ConsumptionSectionHeaderTitle = styled.span`
  padding: 2px 8px;
  border-radius: 8px;
  text-transform: uppercase;
  opacity: 0.8;
  font-size: 0.9rem;
`;

export const ConsumptionSectionHeaderDate = styled.span`
  font-size: 0.9rem;

  span {
    opacity: 0.6;
  }
`;

export const ProgressBarContainer = styled.div<{ size?: number }>`
  margin: 0 auto;
  margin-top: 16px;
  display: flex;
  align-items: center;
  max-width: ${({ size }) => size}px;
  width: 100%;
  padding: 4px;
`;

export const ProgressBarPercentage = styled.span`
  padding: 0 6px;
  font-size: 0.9rem;
`;

export const ProgressBarContent = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 80px;
  height: 16px;
  display: flex;
  background: ${({ theme }) => theme.colors.background1};
  overflow: hidden;
`;

export const ProgressBarContentMain = styled.div<{ percentage: number }>`
  height: 100%;
  text-align: center;
  position: relative;
  width: ${({ percentage }) => `${percentage}%`};
  background: ${({ percentage, theme }) =>
    percentage > 100 ? theme.colors.red : theme.colors.blue};

  ${({ percentage }) =>
    percentage >= 100
      ? css`
          border-radius: 8px;
        `
      : css`
          border-radius: 8px 0 0 8px;
        `}
`;
